import {
    isCrmLookalikeAudience,
    isPixelLookalikeAudience,
    audienceTypeToDefaultSimilarityLevel,
    isPixelBasedPredictiveAudience,
} from '../utils/MyAudienceUtils';

export const useMyAudienceDropdownOption = ({ audienceSize, audienceType, similarityLevelToSize }) => {
    const similarityLevel = audienceTypeToDefaultSimilarityLevel[audienceType];
    const isLookalikeAudience =
        isCrmLookalikeAudience(audienceType) ||
        isPixelLookalikeAudience(audienceType) ||
        isPixelBasedPredictiveAudience(audienceType);

    const size = isLookalikeAudience && similarityLevelToSize ? similarityLevelToSize[similarityLevel] : audienceSize;

    return { audienceSize: size };
};
